import { Button, DatePicker, Flex } from 'antd';
import dayjs from 'dayjs';
import { useBreakpoint } from '@/shared/lib/hooks';
import { PERIOD_PRESETS, activePreset, presetRange } from './periodPresets';
import type { PeriodRange } from './periodPresets';

export interface PeriodFilterProps extends PeriodRange {
  /** Календарная дата магазина `YYYY-MM-DD` — от неё считаются кнопки. */
  today: string;
  onChange: (range: PeriodRange) => void;
}

/** Кнопки «Сегодня / Вчера / Неделя / Месяц» и произвольный период. Выбранной кнопкой
 *  подсвечивается та, чьи границы совпадают с периодом; правка календаря её снимает.
 *  Возвращает фрагмент — раскладку (строка / столбец в листе фильтров) задаёт родитель. */
export function PeriodFilter({ from, to, today, onChange }: PeriodFilterProps) {
  const { isMobile } = useBreakpoint();
  const active = activePreset({ from, to }, today);

  return (
    <>
      <Flex gap={isMobile ? 8 : 4} role="group" aria-label="Период">
        {PERIOD_PRESETS.map(({ value, label }) => (
          <Button
            key={value}
            type={active === value ? 'primary' : 'default'}
            aria-pressed={active === value}
            size={isMobile ? 'large' : undefined}
            // Телефон: четыре кнопки делят ширину листа поровну.
            style={isMobile ? { flex: 1, minWidth: 0, paddingInline: 4 } : undefined}
            onClick={() => onChange(presetRange(value, today))}
          >
            {label}
          </Button>
        ))}
      </Flex>
      <DatePicker.RangePicker
        format="DD.MM.YYYY"
        inputReadOnly={isMobile}
        value={[dayjs(from), dayjs(to)]}
        onChange={(dates) => {
          if (dates && dates[0] && dates[1]) {
            onChange({ from: dates[0].format('YYYY-MM-DD'), to: dates[1].format('YYYY-MM-DD') });
          }
        }}
      />
    </>
  );
}
